import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { I18nProvider, preloadLanguage, savedLanguage, translate } from './i18n';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import './styles/dark-theme.css';
import './styles/dark-base.css';
import { ThemeProvider } from './theme';

// Log environment info for debugging
console.log('App starting...', {
  env: import.meta.env.MODE,
  base: import.meta.env.BASE_URL,
});

// Charge la langue choisie par l'utilisateur avant le premier affichage (pas de flash en français).
preloadLanguage(savedLanguage()).catch(() => { /* repli sur le français */ }).finally(render);

function render() {
try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <I18nProvider>
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </I18nProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
  console.log('App rendered successfully');
} catch (error) {
  console.error('Failed to render app:', error);
  document.getElementById('root')!.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif;">
      <h1>${translate('sh_app_error_title')}</h1>
      <p>${translate('sh_app_error_text')}</p>
      <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${error}</pre>
    </div>
  `;
}
}
